export default __webpack_public_path__ + "static/media/logo101.0261503d.png";